/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDiningTableEdit = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M19.12 15.225a1 1 0 0 1 1.337.068l2.25 2.25a1 1 0 0 1 0 1.414L18.664 23H15v-3.664l4.043-4.043zM17 20.165V21h.836l2.75-2.75-.836-.836zM4 12h3a2 2 0 0 1 2 2v5H7v-5H4v5H2V5h2z" />
        <path d="M17 8a1 1 0 1 1 0 2h-4v7a1 1 0 1 1 0 2h-2a1 1 0 1 1 0-2v-7H7a1 1 0 0 1 0-2z" />
        <path d="M22 14h-5v1h-2v-1a2 2 0 0 1 2-2h3V5h2z" />
      </g>
    </g>
  </Icon>
);
export { SvgDiningTableEdit as DiningTableEdit };
